import React from "react";
import { Wallpaper } from "@mui/icons-material";
import { AdminIconBarItem } from "../icon-bar/AdminIconBarItem";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";
import { SectionTemplates } from "../helpers/enums";

export const WallpaperButton = ({ templateId, onClick }) => {
  const t = useScrollytellTranslation();

  if (templateId === 7 || templateId === SectionTemplates.SCROLL_MAP) {
    return null;
  }

  if (
    templateId === 6 ||
    templateId === SectionTemplates.STICKY_SECTION_MULTI
  ) {
    return (
      <AdminIconBarItem
        Icon={Wallpaper}
        onClick={() => onClick("stickySectionSidebar")}
        tooltip={t(
          "editSectionPanel.multiBackgroundImageTooltip",
          "Administrer bakgrunnsbilder per steg"
        )}
        tooltipPosition="top"
      />
    );
  }

  return (
    <AdminIconBarItem
      Icon={Wallpaper}
      onClick={() => onClick("wallpaperMenu")}
      tooltip={t(
        "editSectionPanel.backgroundImageTooltip",
        "Bakgrunnsbilde valg"
      )}
      tooltipPosition="top"
    />
  );
};
